<section class="buyer-theme">
  <div class="header-topbar-area">
    <app-top-header
      [isLoggedIn]="isLoggedIn"
      [isSellerLoggedIn]="isSellerLoggedIn"
      [isBuyer]="isBuyer"
      (signOut)="handleSignOut()"
    ></app-top-header>
    <app-buyer-header
      [isSellerLoggedIn]="isSellerLoggedIn"
      [isBuyer]="isBuyer"
    ></app-buyer-header>
  </div>
  <main>
    @if (isLoggedIn) {
      <app-toolbox
        [title]="'MY MENU'"
        [menuItems]="menuItems"
        [userName]="userName"
        [colorTheme]="selectedTheme"
        (itemSelected)="onMenuItemSelected($event)"
        (signOut)="handleSignOut()"
        [profileImg]="profileImg"
      ></app-toolbox>
    }
    @if (errorState(); as error) {
      <app-inline-error-status [error]="error"></app-inline-error-status>
    } @else {
      <router-outlet></router-outlet>
    }
    @if (showLogin) {
      <mat-card class="popup-overlay login-popup">
        <mat-card-content class="popup-content">
          <div class="icon-close" (click)="closePopUp()">
            <img
              style="width: 0.9rem"
              src="../../../../../../assets/images/close-icon2.svg"
              alt=""
              />
            </div>
            <div class="login-form-popup">
              <div class="login-form-popup-container">
                <app-logo [link]="buyerDefualtPath"></app-logo>
                <h3
                  class="form-header mt-4"
                  data-translation-key="buyer_login_buyer_login_title"
                  >
                  {{ 'buyer_login.buyer_login_title' | translate }}
                </h3>
                <p
                  class="form-description"
                  data-translation-key="buyer_login_description"
                  >
                  {{ 'buyer_login.description' | translate }}
                </p>
                <form [formGroup]="formData">
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      [placeholder]="'buyer_login.email' | translate"
                      formControlName="email"
                      data-translation-key="buyer_login_email"
                      />
                      <mat-error>
                        @if (formData.get('email')?.hasError('required')) {
                          <span
                            data-translation-key="buyer_login_email_required"
                            >
                            {{ 'buyer_login.email_required' | translate }}
                          </span>
                        }
                        @if (formData.get('email')?.hasError('invalidEmail')) {
                          <span
                            data-translation-key="buyer_login_email_invalid"
                            >
                            {{ 'buyer_login.email_invalid' | translate }}
                          </span>
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="form-fields">
                      <!-- <mat-label>Password</mat-label> -->
                      <input
                        #password
                        type="password"
                        matInput
                        [placeholder]="'buyer_login.password' | translate"
                        formControlName="password"
                        data-translation-key="buyer_login_password"
                        />
                        <button
                          type="button"
                          mat-icon-button
                          matSuffix
                    (click)="
                      password.type =
                        password.type == 'password' ? 'text' : 'password'
                    "
                          >
                          @if (password.type == 'password') {
                            <mat-icon
                              fontIcon="visibility_off"
                            ></mat-icon>
                          }
                          @if (password.type == 'text') {
                            <mat-icon
                              fontIcon="visibility"
                            ></mat-icon>
                          }
                        </button>
                        <mat-error>
                          @if (formData.get('password')?.hasError('required')) {
                            <span
                              data-translation-key="buyer_login_password_required"
                              >
                              {{ 'buyer_login.password_required' | translate }}
                            </span>
                          }
                          @if (
                            formData.get('password')?.hasError('invalidPassword')
                            ) {
                            <span
                              data-translation-key="buyer_login_password_validation"
                              >
                              {{ 'buyer_login.password_validation' | translate }}
                            </span>
                          }
                        </mat-error>
                      </mat-form-field>
                      <div class="text-end">
                        <a
                          [routerLink]="'/buyer/auth/forgot-password' | localeLink"
                          data-translation-key="buyer_login_buyer_login_forgot_your_password"
                          >
                          {{ 'buyer_login.buyer_login_forgot_your_password' | translate }}
                        </a>
                      </div>
                      <button
                        class="btn submit"
                        [disabled]="!formData.valid || loginClicked"
                        (click)="onSubmit()"
                        >
                        @if (loginClicked) {
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        }
                        @if (!loginClicked) {
                          <span
                            data-translation-key="buyer_login_buyer_login_signin"
                            >{{ 'buyer_login.buyer_login_signin' | translate }}</span
                            >
                        }
                      </button>
                    </form>
                    <div class="text-center mt-3">
                      <span data-translation-key="buyer_login_first_time">{{ 'buyer_login.first_time' | translate }}</span>
                      <a
                        [routerLink]="'/buyer/auth/register' | localeLink"
                        data-translation-key="buyer_login_buyer_login_register_now"
                        >
                        {{ 'buyer_login.buyer_login_register_now' | translate }}
                      </a>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          }
        </main>

        <app-buyer-footer></app-buyer-footer>

        <div class="circle-container">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            >
            <g>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.03516 0.416666L7.03516 15H8.28516L8.28516 0.416666H7.03516Z"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.28516 1.04115C8.28516 3.98115 5.70016 6.38281 2.94349 6.38281H2.31849V5.13281H2.94349C5.03599 5.13281 7.03516 3.26448 7.03516 1.04115V0.416979H8.28516V1.04115Z"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.03333 1.04115C7.03333 3.98115 9.61833 6.38281 12.375 6.38281H13V5.13281H12.375C10.2817 5.13281 8.28333 3.26448 8.28333 1.04115V0.416979H7.03333V1.04115Z"
                    />
                  </g>
                </svg>
              </div>
            </section>
